import { gql } from "@apollo/client/core";
import type { TypedDocumentNode } from "@graphql-typed-document-node/core";

// ── Domain types ──────────────────────────────────────────────────────────────

export interface QuickSearchItem {
  brandName: string | null
  id: string
  matchedIdentifier: string | null
  name: string
  sku: string | null
  thumbnailUrl: string | null
}

// ── Query ─────────────────────────────────────────────────────────────────────

export interface QuickSearchInput {
  limit?: number | null
  query?: string | null
}

export interface QuickSearchProductsQueryVariables {
  input: QuickSearchInput
  [key: string]: unknown
}

export interface QuickSearchProductsQueryResult {
  quickSearchProducts: {
    items: QuickSearchItem[]
    total: number
  }
}

export const QUICK_SEARCH_PRODUCTS: TypedDocumentNode<
  QuickSearchProductsQueryResult,
  QuickSearchProductsQueryVariables
> = gql`
  query QuickSearchProducts($input: QuickSearchInput!) {
    quickSearchProducts(input: $input) {
      items {
        brandName
        id
        matchedIdentifier
        name
        sku
        thumbnailUrl
      }
      total
    }
  }
`;
